const slideShow = (slideIndex) => {
  const plusSlides = (n) => showSlides((slideIndex.value += n));
  const currentSlide = (n) => showSlides((slideIndex.value = n));
  const showSlides = (n) => {
    let i;
    const slides = document.getElementsByClassName("mySlides");
    const dots = document.getElementsByClassName("demo");
    const captionText = document.getElementById("caption");
    if (slides) {
      if (n > slides.length) {
        slideIndex.value = 1;
      }
      if (n < 1) {
        slideIndex.value = slides.length;
      }
      for (i = 0; i < slides.length; i++) {
        slides[i].style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }
      slides[slideIndex.value - 1].style.display = "block";
      dots[slideIndex.value - 1].className += " active";
      captionText.href = dots[slideIndex.value - 1].alt.split("_")[0];
      captionText.innerHTML = dots[slideIndex.value - 1].alt.split("_")[1];
    }
  };
  return { plusSlides, currentSlide, showSlides };
};
export default slideShow;
